export default __webpack_public_path__ + "static/media/math-magicians2.5038975f.png";